import { debounce } from 'lodash'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import bpAdmin from '../../../../../assets/data/bpAdmin.json'
import { GlobalAlert } from '../../../../components'
import { TopNavigation } from '../../../../containers'
import { MaintenanceMode } from '../../../../containers/MaintenanceMode/MaintenanceMode'
import { Responsive } from '../../../../containers/Responsive/Responsive'
import { Workspace } from '../../../../containers/Workspace/Workspace'
import { selectFontSizeSetting } from '../../../../utils/slices/settings.slice'
import { APP_CONFIG, GLOBAL_SETTINGS_FONTSIZE_OPTIONS } from '../../common/constants'
import { AboutModal } from '../../components'
import { selectIsValidOutput } from '../../store/slices/output.slice'
import DesktopView from '../DesktopView'
import MobileView from '../MobileView'
import PrintView from '../PrintView/PrintView.container'
import TabletView from '../TabletView'

const PageView = () => {
  const isValid = useSelector(selectIsValidOutput)
  const fontSize = useSelector(selectFontSizeSetting)

  const setMediaClass = (width) => {
    let mediaClass = null

    if (width < 768) {
      mediaClass = '-media-xs'
    } else if (width < 992) {
      mediaClass = '-media-sm'
    } else if (width < 1600) {
      mediaClass = '-media-md'
    } else {
      mediaClass = '-media-lg'
    }
    document.documentElement.classList.remove('-media-xs', '-media-sm', '-media-md', '-media-lg')
    document.documentElement.classList.add(mediaClass)
  }

  useEffect(() => {
    document.documentElement.classList.add(APP_CONFIG.productThemeClasses)
    document.documentElement.classList.remove(
      '-densityCompact',
      '-densityDefault',
      'vertical',
      'horizontal',
    )
    document.documentElement.classList.add(fontSize ?? '-densityCompact', '-themeLight')

    setMediaClass(window.innerWidth)

    const debouncedHandleResize = debounce(() => setMediaClass(window.innerWidth), 500)
    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [])

  return (
    <>
      <TopNavigation
        about={AboutModal}
        appConfig={APP_CONFIG}
        print={PrintView}
        downloadProps={{ disabled: !isValid }}
        settingsProps={{
          fontSizeOptions: GLOBAL_SETTINGS_FONTSIZE_OPTIONS,
        }}
      />

      {bpAdmin && bpAdmin.applications[APP_CONFIG.appCode] === 'off' ? (
        <MaintenanceMode appCode={APP_CONFIG.appCode} appName={APP_CONFIG.appName} />
      ) : (
        <Workspace>
          <GlobalAlert />

          <Responsive.Desktop>
            <DesktopView />
          </Responsive.Desktop>

          <Responsive.Tablet>
            <TabletView />
          </Responsive.Tablet>

          <Responsive.Mobile>
            <MobileView />
          </Responsive.Mobile>
        </Workspace>
      )}
    </>
  )
}

export default PageView
